import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { cleanEmptyParams } from "@/utilities/etc"
import MCALLEN_THEME from "@/utilities/json/McAllenTheme"

export const Route = createFileRoute("/_authenticated")({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    qrLookupID: string | undefined
  } => {
    return cleanEmptyParams({
      qrLookupID: (search.qrLookupID as string) || "",
    })
  },
  beforeLoad: ({ context, search, location }) => {
    if (!context.isAuthenticated) {
      throw redirect({
        to: "/auth/sign-in",
        search: {
          redirect: location.href,
          qrLookupID: search.qrLookupID,
        },
      })
    }

    if (search.qrLookupID) {
      context.setScannedArea({
        qrLookupID: search.qrLookupID,
        theme: MCALLEN_THEME,
      })
      context.setDocumentThemeMode("whiteLabel")
    }
  },
  component: Outlet,
})
